import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles((theme: Theme) => ({
  detailsContainer: {
    minWidth: 750
  }
}));

export default styles;